import Service from '@ember/service';
import { inject as service } from '@ember/service';
import ENV from 'bullitttime-event/config/environment';

export default class AjaxService extends Service
{
	@service errorManager;

	host =  ENV.eventBackendProtocol+"://"+ENV.eventBackendHost+":"+ENV.eventBackendPort+(ENV.eventBackendNamespace ? "/"+ENV.eventBackendNamespace : "");

	async request(url)
	{
		try {
			const response = await fetch(this.host+url);
			if (!response.ok) {
				const errorText = await response.text();
				this.errorManager.addError(
					`API Error: ${response.status} - ${errorText || response.statusText}`,
					{ clearable: true, type: 'api' }
				);
				throw new Error(errorText || response.statusText);
			}
			return response.json();
		} catch (error) {
			if (error.name === 'TypeError') {
				this.errorManager.addError(
					'Network Error: Unable to connect to server',
					{ clearable: true, type: 'network' }
				);
			}
			throw error;
		}
	}

	async post(url, data = {})
	{
		try {
			const response = await fetch(this.host+url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(data)
			});
			if (!response.ok) {
				const errorText = await response.text();
				this.errorManager.addError(
					`API Error: ${response.status} - ${errorText || response.statusText}`,
					{ clearable: true, type: 'api' }
				);
				throw new Error(errorText || response.statusText);
			}
			return response.json();
		} catch (error) {
			if (error.name === 'TypeError') {
				this.errorManager.addError(
					'Network Error: Unable to connect to server',
					{ clearable: true, type: 'network' }
				);
			}
			throw error;
		}
	}
}